// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-modal-files-upload{background:#F9F9F9;padding:1rem 2rem;display:flex;flex-direction:column;min-height:250px}.ac-modal-files-upload .ac-form{flex-grow:1}.ac-modal-files-upload .ac-form__group{flex-grow:1}\n", ""]);
// Exports
module.exports = exports;
